import { OverridableStringUnion } from '@mui/types';
import { ChipPropsColorOverrides } from '@mui/material/Chip/Chip';

const STATUS_COLOR_MAP: { [key: string]: OverridableStringUnion<
'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
ChipPropsColorOverrides> } = {
  fulfilled: 'success',
  paid: 'success',
  partially_refunded: 'primary',
} as const;

export {
  STATUS_COLOR_MAP,
};
